import AddContact from "components/AddContact";
export { default as AlertItem } from "./AlertItem";
export { default as ChoosePremium } from "./ChoosePremium";
export { default as ConfigureButton } from "./ConfigureButton";
export { default as ContactModal } from "./ContactModal";
export { default as DateModal } from "./DateModal";
export { default as EditTitle } from "./EditTitle";
export { default as Footer } from "./Footer";
export { default as Header } from "./Header";
export { default as InstallApp } from "./InstallApp";
export { default as MemoAlert } from "./MemoAlert";
export { default as MemoItem } from "./MemoItem";
export { default as MenuBar } from "./MenuBar";
export { default as PicturesList } from "./PicturesList";
export { default as AddContact } from "./AddContact";
export { default as PremiumButton } from "./PremiumButton";
export * from "./ErrorConfirm";


// WEBPACK FOOTER //
// ./src/components/index.ts